import axios from 'axios'
import { Module } from 'vuex'

const metadataModule: Module<any, any> = {
    actions: {
        async getMetadata({ commit }, link) {
            let data = null

            // Prefer same-origin /meta/fetch (workspace nginx → meta-fetcher), matching legacy.
            // Optional VITE_META_FETCHER_BASE_URL is only for local/dev overrides.
            const baseURL = import.meta.env.VITE_META_FETCHER_BASE_URL || undefined
            const api = axios.create({
                ...(baseURL ? { baseURL } : {}),
                withCredentials: true,
            })

            await api
                .get('/meta/fetch?url=' + encodeURIComponent(link))
                .then((response) => {
                    data = response.data
                })

            return data
        },
    },
}

export default metadataModule
